module.exports = __webpack_public_path__ + "static/img/fxlh-xq.b3c001f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fxlh-xq.png
// module id = p9hB
// module chunks = 0